import {
  DrawerGroups,
  errorToast,
  IErrorMessage,
  ISuccessMessage,
  List,
  renderToastContainer,
  successToast
} from 'enchoice-fabric-react-lib';
import { CommandBar, IColumn, IObjectWithKey, Selection, SelectionMode } from 'office-ui-fabric-react';
import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router';
import { Dispatch } from 'redux';
import Api from '../../../components/Api';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';
import './DrawerGroupsAdmin.css';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

const URL_BASE = '';

const divStyle = {
  height: 'calc(100% - 85px)',
  fallbacks: [{ height: '-moz-calc(100% - 85px)' }, { height: '-webkit-calc(100% - 85px)' }, { height: '-o-calc(100% - 85px)' }]
};

class DrawerGroupsAdmin extends React.PureComponent<any, any> {
  private selection: Selection;

  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      drawerGroupId: params.drawerGroupId,
      showList: true
    };

    this.onCancel = this.onCancel.bind(this);
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
    this.onSubmitError = this.onSubmitError.bind(this);
    this.isNull = this.isNull.bind(this);
    this.getUrl = this.getUrl.bind(this);
    this.onCustomBuildColumns = this.onCustomBuildColumns.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onNew = this.onNew.bind(this);
    this.onDelete = this.onDelete.bind(this);

    this.selection = new Selection({
      getKey: (item: IObjectWithKey, index?: number | undefined): string | number => {
        return item && (item as any).id ? (item as any).id : `${index}`;
      },
      onSelectionChanged: () => {
        this.onSelectionChanged(this.selection.getSelection());
      }
    });
  }

  public componentDidUpdate(prevProps: any) {
    const lastIdArray = /\w+/.exec(prevProps.location.pathname.replace(prevProps.match.url, ''));

    if (lastIdArray) {
      const lastId = lastIdArray[0];
      const id = this.getIdArray();
      if (lastId && id == null) {
        this.setState({ showList: false }, () => this.setState({ showList: true }));
      }
    }
  }

  public componentDidMount() {
    const { t } = this.props;

    const items: IBreadcrumbItem[] = [
      { text: t('drawerGroupAdmin.breadcrumb.home'), key: '/home' },
      { text: t('drawerGroupAdmin.breadcrumb.1level'), key: `/search/drawergroups`, isCurrentItem: true }
    ];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    const { t, match } = this.props;

    const id = this.getIdArray();

    return (
      <div className="ms-Grid" dir="ltr" style={{ padding: 0, height: '100%' }}>
        <div className="ms-Grid-row" style={{ height: '100%' }}>
          <div className="ms-Grid-col ms-sm4" style={{ padding: 0, height: '100%', borderRight: '1px solid #eaeaea' }}>
            <CommandBar
              items={this.getItems()}
              farItems={this.getFarItems()}
              ariaLabel={'Use left and right arrow keys to navigate between commands'}
            />
            {this.state.showList && (
              <div style={divStyle}>
                <List
                  getUrl={this.getUrl}
                  handleResponse={this.handleResponse}
                  onCustomBuildColumns={this.onCustomBuildColumns}
                  selection={this.selection}
                  selectionMode={SelectionMode.single}
                  selectKeyOnInit={`${id}`}
                  enableSearch={true}
                  enableSort={true}
                  height={'100%'}
                  underlined={true}
                  styles={{ root: { marginTop: '5px', height: '100%' } }}
                />
              </div>
            )}
          </div>
          <div className="ms-Grid-col ms-sm8" style={{ padding: 0 }}>
            <Switch>
              <Route
                exact={true}
                path={`${match.url}/new`}
                // tslint:disable-next-line:jsx-no-lambda
                render={props => (
                  <div>
                    <DrawerGroups
                      onCancel={this.onCancel}
                      onSubmitSuccess={this.onSubmitSuccess}
                      onSubmitError={this.onSubmitError}
                      title={t('drawerGroupAdmin.title.new')}
                      labelCmdBarBtnSave={t('drawerGroupAdmin.form.cmdBar.save')}
                      labelCmdBarBtnEdit={t('drawerGroupAdmin.form.cmdBar.edit')}
                      labelCmdBarBtnCancel={t('drawerGroupAdmin.form.cmdBar.cancel')}
                      labelValidationMessage={t('drawerGroupAdmin.form.validation.required')}
                      labelDrawerGroupsValidationMessage={t('drawerGroupAdmin.form.validation.drawers')}
                      labelFormName={t('drawerGroupAdmin.form.fields.name')}
                      labelFormSite={t('drawerGroupAdmin.form.fields.site')}
                      labelFormSitePlaceholder={t('drawerGroupAdmin.form.fields.sitePlaceholder')}
                      labelFormDescription={t('drawerGroupAdmin.form.fields.description')}
                      labelFormMovableAvailable={t('drawerGroupAdmin.form.fields.available')}
                      labelFormMovableSelected={t('drawerGroupAdmin.form.fields.selected')}
                      labelFormMovableProperty={t('drawerGroupAdmin.form.fields.movProperty')}
                      baseUrl={URL_BASE}
                    />
                  </div>
                )}
              />
              <Route
                exact={true}
                path={`${match.url}/:drawerGroupId/edit`}
                // tslint:disable-next-line:jsx-no-lambda
                render={props => (
                  <div>
                    <DrawerGroups
                      onCancel={this.onCancel}
                      onSubmitSuccess={this.onSubmitSuccess}
                      onSubmitError={this.onSubmitError}
                      id={props.match.params.drawerGroupId}
                      title={t('drawerGroupAdmin.title.edit')}
                      labelCmdBarBtnSave={t('drawerGroupAdmin.form.cmdBar.save')}
                      labelCmdBarBtnEdit={t('drawerGroupAdmin.form.cmdBar.edit')}
                      labelCmdBarBtnCancel={t('drawerGroupAdmin.form.cmdBar.cancel')}
                      labelValidationMessage={t('drawerGroupAdmin.form.validation.required')}
                      labelDrawerGroupsValidationMessage={t('drawerGroupAdmin.form.validation.drawers')}
                      labelFormName={t('drawerGroupAdmin.form.fields.name')}
                      labelFormSite={t('drawerGroupAdmin.form.fields.site')}
                      labelFormSitePlaceholder={t('drawerGroupAdmin.form.fields.sitePlaceholder')}
                      labelFormDescription={t('drawerGroupAdmin.form.fields.description')}
                      labelFormMovableAvailable={t('drawerGroupAdmin.form.fields.available')}
                      labelFormMovableSelected={t('drawerGroupAdmin.form.fields.selected')}
                      labelFormMovableProperty={t('drawerGroupAdmin.form.fields.movProperty')}
                      baseUrl={URL_BASE}
                    />
                  </div>
                )}
              />
            </Switch>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12" style={{ height: '1px' }}>
            {renderToastContainer()}
          </div>
        </div>
      </div>
    );
  }

  private onCustomBuildColumns(): IColumn[] {
    console.log('Set custom columns');
    return [
      {
        key: 'name',
        name: 'Name',
        fieldName: 'name',
        minWidth: 100,
        maxWidth: 150,
        isRowHeader: true,
        isResizable: false,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        data: 'string',
        isPadded: true
      },
      {
        key: 'site',
        name: 'Site',
        fieldName: 'site',
        minWidth: 100,
        maxWidth: 150,
        isRowHeader: true,
        isResizable: false,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        data: 'string',
        isPadded: true
      },
      {
        key: 'drawers',
        name: 'Drawers',
        fieldName: 'groups',
        minWidth: 100,
        maxWidth: 150,
        isRowHeader: true,
        isResizable: false,
        isSorted: false,
        data: 'number',
        isPadded: true
      }
    ];
  }

  private onSelectionChanged(selection: IObjectWithKey[]) {
    if (selection.length === 1) {
      this.props.history.push(`/search/drawergroups/${(selection[0] as any).id}/edit`);
    } else {
      this.props.history.push(`/search/drawergroups/`);
    }
  }

  private isNull(value: any) {
    return value == null || value === 'null' || value === undefined;
  }

  private handleResponse(items: any[]) {
    return items;
  }

  private getUrl(search: string, page: number, sortBy?: string, sortDesc?: boolean) {
    const qValue = this.isNull(search) ? '' : `&q=${search}`;
    const sortByValue = this.isNull(sortBy) ? '' : `&_sort=${sortBy}`;
    let sortDescValue = '';

    if (!this.isNull(sortDesc)) {
      sortDescValue = sortDesc ? '&_order=desc' : '&_order=asc';
    }
    const url = `${URL_BASE}/drawergroups?_start=${page}&_limit=20${qValue}${sortByValue}${sortDescValue}`;
    console.log(url);
    return url;
  }

  private onCancel(): void {
    console.log('onCancel ...');
    this.selection.setAllSelected(false);

    this.props.history.push(`/search/drawergroups/`);
  }

  private onSubmitSuccess(response: any): void {
    console.log('onSubmitSuccess ...', response);
    const id = this.getIdArray();
    const message = id ? 'Drawer Group edited.' : 'Drawer Group created';
    const msg: ISuccessMessage = {
      title: 'Success',
      message
    };
    successToast(msg);
    this.selection.setAllSelected(false);
    this.props.history.push(`/search/drawergroups/`);
  }

  private onSubmitError(error: any): void {
    const errorObj = error.response.data;
    const id = this.getIdArray();
    const title = id ? 'Error editing Drawer Group' : 'Error creating new Drawer Group';
    const msg: IErrorMessage = {
      title,
      message: errorObj.message,
      error: errorObj
    };
    errorToast(msg);
  }

  private getItems = () => {
    const { t } = this.props;
    return [
      {
        key: 'newItem',
        name: t('drawerGroupAdmin.list.cmdBar.new'),
        iconProps: {
          iconName: 'Add'
        },
        onClick: this.onNew
      }
    ];
  };

  private getFarItems = () => {
    const { t } = this.props;
    return [
      {
        key: 'delete',
        name: t('drawerGroupAdmin.list.cmdBar.delete'),
        iconProps: {
          iconName: 'Delete'
        },
        onClick: this.onDelete
      }
    ];
  };

  private getIdArray(): any {
    return /\w+/.exec(this.props.location.pathname.replace(this.props.match.url, ''));
  }

  private onNew() {
    this.selection.setAllSelected(false);
    this.props.history.push(`/search/drawergroups/new`);
  }

  private onDelete(): any {
    const drawerGroupId = this.getIdArray();
    const id = drawerGroupId ? drawerGroupId[0] : undefined;

    if (!id) {
      return;
    }

    Api.delete(`drawergroups/${id}`)
      .then(response => {
        const msg: ISuccessMessage = {
          title: 'Success',
          message: 'Drawer Group Deleted with success!'
        };
        successToast(msg);
        this.selection.setAllSelected(false);
        this.props.history.push(`/search/drawergroups/`);
      })
      .catch(error => {
        const data = error.response.data;
        const msg: IErrorMessage = {
          title: 'Error',
          message: `Error Deleting Drawer Group: ${data.status}:${data.message}`,
          error: data
        };
        errorToast(msg);
      });
  }
}

export default withRouter(connect(
  null,
  mapDispatchToProps
)(withTranslation()(DrawerGroupsAdmin)) as any);
